const UserType = {
  Normal: 'Normal',
  Developer: 'Developer',
  Admin: 'Admin',
  StationMaster: 'StationMaster'
}

export default UserType
